import {Component, OnInit} from '@angular/core';
import {User} from "../../models/user";
import {AuthService} from "../../services/auth/auth.service";
import {Router} from "@angular/router";

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

    user: User;

    projectId: string;
    databaseId: string;

    constructor(
        private authService: AuthService,
        private router: Router,
    ) {
    }

    ngOnInit() {
        if (!this.authService.isLoggedIn())
          return this.router.navigateByUrl('login').catch(console.error);
        else {
          this.user = this.authService.getUser();
        }
    }

    changeProject(projectId: string): void {
        this.projectId = projectId;
    }

    deselectProject() {
      this.projectId = null;
    }
}
